import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useState, useRef } from "react";
import { Toast } from "primereact/toast";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("feedback@web");
  const [message, setMessage] = useState("");
  const toast = useRef<Toast>(null);

  const handleSubmit = () => {
    if (!name || !email || !message) {
      toast.current?.show({ severity: "warn", summary: "Incomplete", detail: "Please fill all fields" });
      return;
    }

    // const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // if (!validEmail) {
    //   toast.current?.show({ severity: "error", summary: "Invalid Email", detail: "Please enter a valid email" });
    //   return;
    // }

    // 这里可以调用后台 API 保存用户反馈
    console.log({ name, email, message });

    toast.current?.show({ severity: "success", summary: "Submitted", detail: "Thank you for your message." });

    // 重置表单
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: 20 }}>
      <Toast ref={toast} />
      <h2>Feedback Field</h2>
      <div className="p-field">
        <label htmlFor="name">Title</label>
        <InputText id="name" value={name} onChange={(e) => setName(e.target.value)} style={{ width: "100%" }} />
      </div>
      {/* <div className="p-field">
        <label htmlFor="email">Email</label>
        <InputText id="email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: "100%" }} />
      </div> */}
      <div className="p-field">
        <label htmlFor="message">Message</label>
        <InputTextarea id="message" value={message} onChange={(e) => setMessage(e.target.value)} rows={5} style={{ width: "100%" }} />
      </div>
      <Button label="Submit" onClick={handleSubmit} className="p-mt-2" />
      <p style={{ fontSize: 12, color: "#666", marginTop: 8 }}>
        We respect your privacy. Your information will only be used to respond to your inquiry.
      </p>
    </div>
  );
}
